<template>
  <ContentWrapperControl
    no_bottom
    full_width
    class="min-h-screen bg-primary flex flex-col items-center justify-center p-5"
  >
    <img
      :src="getImage('ga/', 'papsi_logo.png')"
      alt="PAPSI Logo"
      class="h-6 w-auto object-contain mb-4"
    />

    <div
      v-text="lang('lbl_0000202')"
      class="text-white font-semibold text-center text-xl p-5"
    ></div>

    <div class="bg-white shadow rounded-lg p-6 w-full max-w-sm relative z-10">
      <div
        class="relative mx-auto mb-6 w-32 h-32 flex items-center justify-center"
      >
        <img
          class="absolute -top-6 w-24 h-24 object-contain"
          :src="getImage('pia/images/elements/', 'papsi_kalabaw.png')"
        />

        <div
          class="w-32 h-32 rounded-full flex items-center justify-center bg-secondary-20"
        >
          <div class="w-24 h-24 rounded-full bg-secondary-50"></div>
        </div>
      </div>

      <div class="mb-5">
        <SpecialRatingControl
          :submit="submit_rating"
          :type="1"
          @toggled="toggled"
          @categories-changed="onCategoriesChanged"
        />
      </div>

      <div class="flex">
        <ButtonControl class="mr-3 flex-1" outline @click="skip">
          {{ lang("lbl_0000199") }}
        </ButtonControl>

        <ButtonControl
          class="flex-1"
          :disabled="disabled"
          @click="submitRating"
        >
          {{ lang("lbl_0000190") }}
        </ButtonControl>
      </div>
    </div>

    <div class="ray-background absolute inset-0 z-0"></div>
  </ContentWrapperControl>
</template>

<script>
import ContentWrapperControl from "@/components/controls/ContentWrapperControl.vue";
import SpecialRatingControl from "@/components/controls/SpecialRatingControl.vue";
import ButtonControl from "@/components/controls/ButtonControl.vue";
import mixin from "@/mixin";

export default {
  mixins: [mixin],
  components: {
    ButtonControl,
    ContentWrapperControl,
    SpecialRatingControl,
  },
  data() {
    return {
      disabled: true,
      submit_rating: false,
      current_rating: 5,
      selected_categories: [],
    };
  },
  mounted() {
    this.$emit("checkauth", true);
    this.$emit("nofooter", true);
    this.$emit("hidenavbar");
  },
  methods: {
    toggled(n) {
      this.current_rating = n;

      if (n === 5) {
        this.disabled = false;
      } else {
        this.disabled = this.selected_categories.length === 0;
      }
    },

    skip() {
      this.$router.push("/dashboard");
    },

    onCategoriesChanged(categories) {
      this.selected_categories = categories;

      if (this.current_rating < 5) {
        this.disabled = this.selected_categories.length === 0;
      }
    },

    submitRating() {
      this.submit_rating = true;
      this.$router.push("/dashboard");
    },
  },
};
</script>

<style scoped>
.ray-background {
  background: repeating-conic-gradient(
    rgba(255, 255, 255, 0.05) 0deg 20deg,
    transparent 20deg 40deg
  );

  position: fixed;
  top: 50%;
  left: 50%;

  width: 200vmax;
  height: 200vmax;

  transform: translate(-50%, -50%);
  animation: rotate-rays 30s linear infinite;

  pointer-events: none;
}

@keyframes rotate-rays {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
</style>
